var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "padd30" },
    [
      _c("h2", { staticClass: "f18 fb normal gray_2" }, [_vm._v("货品管理")]),
      _c("div", { staticClass: "box20" }),
      _vm._m(0),
      _c("div", { staticClass: "flex_space_between pad20_tb" }, [
        _c(
          "div",
          [
            _c("el-input", {
              attrs: { placeholder: "请输入内容" },
              model: {
                value: _vm.good_search,
                callback: function($$v) {
                  _vm.good_search = $$v
                },
                expression: "good_search"
              }
            }),
            _c("el-button", { attrs: { type: "primary" } }, [_vm._v("搜索")]),
            _c("el-button", [_vm._v("重置")])
          ],
          1
        ),
        _c(
          "div",
          [
            _c("el-button", [_vm._v("导出")]),
            _c("el-button", { attrs: { type: "primary" } }, [
              _vm._v("添加货品")
            ])
          ],
          1
        )
      ]),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticClass: "t_center",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "50" } }),
          _c("el-table-column", {
            attrs: { label: "商品名称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(scope.row.name))]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "商品图" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("img", { attrs: { src: scope.row.picUrl, alt: "" } })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", { attrs: { prop: "unit", label: "计量单位" } }),
          _c("el-table-column", { attrs: { prop: "price", label: "价格" } }),
          _c("el-table-column", {
            attrs: { prop: "sellUnit", label: "销售单位" }
          }),
          _c("el-table-column", {
            attrs: { prop: "conversion", label: "换算比例" }
          }),
          _c("el-table-column", { attrs: { prop: "classify", label: "分类" } }),
          _c("el-table-column", {
            attrs: { prop: "inventory", label: "库存" }
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.status === 1
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v("审核中")
                        ])
                      : _vm._e(),
                    scope.row.status === 2
                      ? _c("el-tag", { attrs: { type: "warning" } }, [
                          _vm._v("已审核")
                        ])
                      : _vm._e(),
                    scope.row.status === 3
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("出售中")
                        ])
                      : _vm._e(),
                    scope.row.status === 4
                      ? _c("el-tag", { attrs: { type: "info" } }, [
                          _vm._v("已下架")
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c(
            "el-table-column",
            { attrs: { width: "130", label: "操作" } },
            [
              [
                _c("span", { staticClass: "c_blue cursor" }, [_vm._v("删除")]),
                _c("span", { staticClass: "pad10_l c_blue cursor" }, [
                  _vm._v("编辑")
                ]),
                _c("span", { staticClass: "pad10_l c_blue cursor" }, [
                  _vm._v("上架")
                ])
              ]
            ],
            2
          )
        ],
        1
      ),
      _c("div", { staticClass: "box20" }),
      _c(
        "div",
        { staticClass: "t_right" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 30, 40],
              "page-size": 10,
              layout: "total, sizes, prev, pager, next, jumper",
              total: 40
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "classify_list" }, [
      _c("ul", { staticClass: "clear" }, [
        _c("li", { staticClass: "active_classify" }, [_vm._v("全部")]),
        _c("li", [_vm._v("出售中")]),
        _c("li", [_vm._v("已下架")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }